/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Redo16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zm1.313 2.743c.162 0 .301.054.417.178l2.057 2.088a.685.685 0 01.21.487c0 .178-.078.34-.21.472l-2.064 2.11a.59.59 0 01-1.005-.433c0-.146.053-.309.177-.41l.92-.858.449-.324-.828.038H7.147c-1.09 0-1.902.78-1.902 1.909 0 1.16.908 1.8 2.022 1.8h1.082c.372 0 .647.217.647.604 0 .386-.268.596-.654.596H7.267C5.442 12 4 10.856 4 9s1.33-3.084 3.147-3.084h2.29l.827.039-.58-.449-.781-.75a.543.543 0 01-.186-.418.59.59 0 01.596-.595z"
        />
    </AccessibleSVG>
);

export default Redo16;
